import { createAction, props } from '@ngrx/store'

import {
  ActionDefinition,
  NodeDefinition,
} from '@flowx/designer/modules/core/dictionary/process.dictionary'

export const getNodeActions = createAction('[NODE UI] Get Action', props<{ nodeId: number }>())

export const saveAction = createAction(
  '[ACTION EDIT] Save Action',
  props<{ action: ActionDefinition; oldAction: ActionDefinition }>()
)

export const updateActionSuccess = createAction(
  '[ACTION EFFECTS] Update Action Success',
  props<{ nodeId: number; action: ActionDefinition; oldAction: ActionDefinition }>()
)

export const selectAction = createAction(
  '[ACTIONS TREE] Select Action',
  props<{ actionId: number }>()
)

export const createNodeAction = createAction(
  '[ACTIONS TREE] Create Action',
  props<{ node: NodeDefinition; nodeAction: ActionDefinition; parentAction: ActionDefinition }>()
)

export const deleteAction = createAction(
  '[ACTIONS TREE] Delete Action',
  props<{ action: ActionDefinition }>()
)

export const deleteActionSuccess = createAction(
  '[ACTION EFFECTS] Delete Action Success',
  props<{ nodeId: number; action: ActionDefinition }>()
)
